@if (adresse.adresszusatz1) {
    <div>
        <span class="ewk-label">{{
            'EWK_ADRESSE_ADRESSZUSATZ_1' | translate
        }}</span>
        {{ adresse.adresszusatz1 }}
    </div>
}
@if (adresse.adresszusatz2) {
    <div>
        <span class="ewk-label">{{
            'EWK_ADRESSE_ADRESSZUSATZ_2' | translate
        }}</span>
        {{ adresse.adresszusatz2 }}
    </div>
}
@if (adresse.hausnummer) {
    <div>
        <span class="ewk-label">{{
            'EWK_ADRESSE_HAUSNUMMER' | translate
        }}</span>
        {{ adresse.hausnummer }}
    </div>
}
@if (adresse.wohnungsnummer) {
    <div>
        <span class="ewk-label">{{
            'EWK_ADRESSE_WOHNUNGSNUMMER' | translate
        }}</span>
        {{ adresse.wohnungsnummer }}
    </div>
}
@if (adresse.strasse) {
    <div>
        <span class="ewk-label">{{ 'EWK_ADRESSE_STRASSE' | translate }}</span>
        {{ adresse.strasse }}
    </div>
}
@if (adresse.postleitzahl) {
    <div>
        <span class="ewk-label">{{ 'EWK_ADRESSE_PLZ' | translate }}</span>
        {{ adresse.postleitzahl }}
    </div>
}
@if (adresse.ort) {
    <div>
        <span class="ewk-label">{{ 'EWK_ADRESSE_ORT' | translate }}</span>
        {{ adresse.ort }}
    </div>
}
@if (adresse.gebiet) {
    <div>
        <span class="ewk-label">{{ 'EWK_ADRESSE_KANTON' | translate }}</span>
        {{ adresse.gebiet }}
    </div>
}
